import Footer from "../../../navigation/footerContainer";
import FavoritePropertiesContainer from "./favoriteProperties";

export default function FavoritePropertiesPage(){
    return (
        <>
            <FavoritePropertiesContainer />
            <Footer />
        </>
    )
}